// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EdgeDataPlatformSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="EdgeDataPlatformSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M6.988 6.033H3.483A.483.483 0 0 0 3 6.516v3.502a.483.483 0 0 0 .483.483h3.505A.483.483 0 0 0 7.47 10.02V6.515a.483.483 0 0 0-.483-.483" />
      <path d="M15.798 3H11.91a2.2 2.2 0 0 0-2.202 2.201v3.72c-.012.343-.102 2-.808 2.714-1.116 1.131-2.052 1.17-2.828 1.135a3 3 0 0 0-.282-.017H5.75a4 4 0 0 0-.427-.005l.01.008A2.46 2.46 0 0 0 3 15.212v.329A2.46 2.46 0 0 0 5.46 18h.33a2.46 2.46 0 0 0 2.46-2.46v-.328a2.5 2.5 0 0 0-.029-.378c-.027-.758.05-1.665 1.14-2.74.74-.73 2.494-.8 2.748-.807h3.689A2.2 2.2 0 0 0 18 9.086V5.201A2.2 2.2 0 0 0 15.798 3" />
      <path d="M14.14 13.494h-1.294a.847.847 0 0 0-.847.846v1.292a.847.847 0 0 0 .847.846h1.293a.847.847 0 0 0 .847-.846V14.34a.847.847 0 0 0-.847-.847" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EdgeDataPlatformSignetIcon = /* @__PURE__ */ Object.assign(
  EdgeDataPlatformSignetIconComponent,
  { displayName: 'EdgeDataPlatformSignetIcon' },
);
